module.exports = __webpack_public_path__ + "img/receipt.a3a6bcab.svg";